import { useContext } from 'react';
import { PdfStatusContext, PdfStatusContextType } from '../contexts/PdfStatusContextDef';

export const usePdfStatus = (): PdfStatusContextType => {
  const context = useContext(PdfStatusContext);
  if (!context) {
    throw new Error('usePdfStatus must be used within a PdfStatusProvider');
  }
  return context;
};